import storeRequest from './request/storeRequest';

export const FEED_STATUS_FLOW = ['NOT_IMPORT', 'IMPORTING', 'IMPORTED', 'PUBLISHING', 'PUBLISHED'];
export const FAILED_IMPORT = 'FAILED_IMPORT';
export const FAILED_PUBLISH = 'FAILED_PUBLISH';
export const initFeed = {
  _id: '',
  name: '',
  status: 'active',
  products: [],
  stores: [],
  createdAt: '2026-01-09T03:09:59.552Z',
  updatedAt: '2026-01-09T03:30:56.214Z',
  productCount: 0,
  storeCount: 0,
  image: '',
};

export const feedService = {
  getFeeds(params) {
    return storeRequest.get('/catalogs/fb-catalog-store/list', { params });
  },
  importFBCatalog(data) {
    return storeRequest.post('/catalogs/fb-catalog-store/import', data);
  },
  publishFBCatalog(data) {
    return storeRequest.post('/catalogs/fb-catalog-store/publish', data);
  },
  createCatalog(data) {
    return storeRequest.post('/catalogs/fb-catalog-store/create', data);
  },
  updateCatalog(id, data) {
    return storeRequest.put(`/catalogs/fb-catalog-store/edit/${id}`, data);
  },
  deleteCatalog(id) {
    return storeRequest.delete(`/catalogs/fb-catalog-store/delete/${id}`);
  },
  autoSyncCatalog(id, data) {
    return storeRequest.put(`/catalogs/fb-catalog-store/auto-sync/${id}`, data);
  },
};
